<template>
  <div class="header-container">
    <div class="header-back">
      <div class="header-search">
        <input type="text" placeholder="请输入搜索关键词">
        <span>搜索</span>
      </div>
    </div>
    <div class="header-menu-container">
      <div class="header-menu">
        <div
          v-for="(item, index) in menus"
          :key="index"
          class="header-menu-item"
          :class="{'header-menu-item-check': curHeader === index}"
          @click="$router.push(item.url)"
        >{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    curHeader: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      menus: [
        { name: '首页', url: '/' },
        { name: '党的建设', url: '/construct' },
        { name: '协会概况', url: '/general' },
        { name: '协会要闻', url: '/association' },
        { name: '政策法规', url: '/policy' },
        { name: '公示公告', url: '/publicity' },
        { name: '文件通知', url: '/notice' },
        { name: '产品信息', url: '/product' },
        { name: '曝光台', url: '/exposure' },
        // { name: '信息查询', url: '' },
        { name: '会员风采', url: '/member' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  .header-back {
    width: 100%;
    height: 400px;
    background-image: url("../../assets/img/Banner.png");
    background-size: cover;
    background-position: center center;
    position: relative;
    .header-search {
      position: absolute;
      left: 50%;
      bottom: 40px;
      transform: translate(-50%, 0);
      width: 1200px;
      height: 40px;
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      input {
        width: 250px;
        height: 40px;
        border: 1px solid #dbdfe4;
        outline: none;
        padding: 0 10px;
      }
      span {
        display: inline-block;
        width: 70px;
        height: 40px;
        background: #1279EC;
        font-size: 16px;
        color: #fff;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .header-menu-container {
    background-color: #1279EC;
    width: 100%;
    color: #fff;
    .header-menu {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .header-menu-item {
        flex: 1;
        text-align: center;
        line-height: 50px;
        font-size: 16px;
        cursor: pointer;
        transition: all 300ms;
      }
      .header-menu-item:hover {
        background: rgba(#BCDCFF, 0.2);
      }
      .header-menu-item-check {
        //font-size: 20px;
        background: rgba(#BCDCFF, 0.2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue